/* App component */
import * as Sentry from "@sentry/react";
import React, { useEffect } from "react";
import { detectBrowserLanguage } from "components/util/l.lib";
import applySentryEnvironment from "components/util/sentry";
import DevExtensionLive from "components/util/helpers/DevExtensionLive";
import View from "./App.view";


function App() {
	
	applySentryEnvironment();

	// TODO: Hack -> To remove the resizeObserver error
	useEffect(() => {
		const errorHandler = (e) => {
			if (e.message.includes(
				"ResizeObserver loop completed with undelivered notifications" ||
				"ResizeObserver loop limit exceeded"
			)) {
				const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
				if (resizeObserverErr) resizeObserverErr.style.display = "none";
			}
		};
		window.addEventListener("error", errorHandler);
		return () => window.removeEventListener("error", errorHandler);
	}, []);

	// Detect browser language on app load
	useEffect(() => {
		const browserLang = detectBrowserLanguage();
		localStorage.setItem("language", browserLang);
	}, []);

  return (
		// Sentry error boundary to catch errors in the app.
		<Sentry.ErrorBoundary fallback={null}>
			<DevExtensionLive />
			<View />
		</Sentry.ErrorBoundary>
	);
}

export default App;